<agpr-take-over-panel
    header="Styles.manageDialog.header"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [minPanelWidth]="550"
    [maxPanelWidth]="900"
>
    <div class="agpr-manage-styles">
        <agpr-table
            id="existingStyleTable"
            class="agpr-manage-styles-table"
            [columns]="styleColumnDefs"
            [sortColumn]="primaryColumnDef"
            [showDelete]="true"
            deleteLabel="Styles.manageDialog.deleteStyle"
            [(ngModel)]="styleRows"
            (ngModelChange)="checkForSelected()"
            (itemChanged)="saveStyle($event)"
            (itemDelete)="deleteStyle($event)"
            [vsItemSize]="35"
            [vsMinBufferPx]="350"
            [vsMaxBufferPx]="700"
        ></agpr-table>
    </div>
    <ng-template #takeOverFooterRight>
        <agpr-button
            *ngIf="hasSelectedStyles"
            [label]="'delete' | localize"
            [style]="buttonTypes.primaryB"
            (click)="deleteSelectedStyles()"
        ></agpr-button>
        <agpr-button
            label="done"
            [style]="buttonTypes.primary"
            (click)="hideSlideOverlay = true;"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>